<template>
  <div>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div v-for="(notification, index) in notifications" :key="index" class="col-xl-4 col-sm-6">
        <div class="card">
          <div class="card-body">
            <div class="media">
              <div class="avatar-md me-4 p-3">
                   <span
                       class="avatar-title rounded-circle font-size-20"
                       :class="`bg-${notificationType[notification.data.type].variant}`"
                   >
                    <i :class="notificationType[notification.data.type].icon"></i>
                  </span>
              </div>

              <div class="media-body overflow-hidden">
                <h5 class="text-truncate font-size-15">
                  <a href="javascript: void(0);" class="text-dark">{{
                      notification.data.title
                    }}</a>
                </h5>
                <p class="text-muted mb-4">{{ notification.data.message }}</p>
              </div>
            </div>
          </div>
          <div class="px-4 py-3 border-top">
            <ul class="list-inline mb-0">
              <li class="list-inline-item me-3">
                <f-badge :variant="notification.read_at ? 'success' : 'primary'">
                  {{ notification.read_at ? 'Read' : 'Unread' }}
                </f-badge>
                >
              </li>
              <li
                  v-b-tooltip.hover.top
                  class="list-inline-item me-3"
                  title="Due Date"
              >
                <i class="bx bx-calendar me-1"></i>
                {{ notification.created_at }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->

    <div class="row">
      <div class="col-12">
        <div class="text-center my-3">
          <infinite-loading @infinite="infiniteHandler">
            <div slot="spinner">{{ $t('pages.notifications.loading') }}</div>
            <div slot="no-more">{{ $t('pages.notifications.no_more') }}</div>
            <div slot="no-results">{{ $t('pages.notifications.not_found') }}</div>
          </infinite-loading>
        </div>
      </div>
      <!-- end col-->
    </div>
    <!-- end row -->
  </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';
import NotificationService from "../../Services/Api/NotificationService";
import {notificationMethods} from "@/state/helpers";
import NotificationMixin from "../../mixins/NotificationMixin";

export default {
  page() {
    return {
      title: this.$t('pages.notifications.title'),
      meta: [
        {
          name: "description",
          content: this.$t('common.app_title')
        }
      ]
    }
  },
  mixins: [NotificationMixin],
  components: {
    InfiniteLoading,
  },
  data() {
    return {
      title: this.$t('pages.notifications.title'),
      items: [
        {
          text: this.$t('pages.notifications.items.first'),
          href: "/",
        },
        {
          text: this.$t('pages.notifications.items.second'),
          active: true,
        },
      ],
      notifications: [],
      paginate: 20,
      page: 1,
    };
  },
  methods: {
    ...notificationMethods,
    async infiniteHandler(state) {
      await NotificationService.all({query: `paginate=${this.paginate}&page=${this.page}`}).then((res) => {
        const data = res.data.data
        if (data.length) {
          this.page += 1;
          this.notifications.push(...data);
          state.loaded();
        } else {
          state.complete();
        }
        res.data.data
      }).finally(() => {
        if (this.page < 3) {
          this.clearNotifications()
        }
      })
    },
  },
};
</script>

